import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { Menu } from 'semantic-ui-react'

const SingleProjectMenu = ({ match, history }) => {
    const [activeItem, setActiveItem] = useState('details')

    useEffect(() => {
        setActiveItem(match.url.split(`/`)[3] || 'details')
    }, [match.url])

    const onNavigate = (e, { name }) => {
        setActiveItem(name)
        history.replace(`/projects/${match.params.id}/${name}`)
    }

    return (
        <Menu tabular style={{ clear: 'both' }}>
            <Menu.Item
                name="details"
                active={activeItem === 'details'}
                onClick={onNavigate}
            >
                Project details
            </Menu.Item>
            <Menu.Item
                name="email-template"
                active={activeItem === 'email-template'}
                onClick={onNavigate}
            >
                Email templates
            </Menu.Item>
            <Menu.Item
                name="experts"
                active={activeItem === 'experts'}
                onClick={onNavigate}
            >
                Find experts
            </Menu.Item>
            <Menu.Item
                name="manage-experts"
                active={activeItem === 'manage-experts'}
                onClick={onNavigate}
            >
                Manage experts
            </Menu.Item>
        </Menu>
    )
}

export default withRouter(SingleProjectMenu)
